
























import { defineComponent, ref } from "@vue/composition-api";
import { BlockedLocationAutocomplete } from "@scrile/api-provider/dist/api/BlockedLocationsProvider";
import { Gender } from "@scrile/api-provider/dist/api/UserProvider";
import { PreferredGender, RelationshipRole } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { updateHasLocation } from "@/hooks/useGeolocation";
import Store from "@/store";
import { MUTATION_TYPES } from "@/store/const";
import providers from "@/lib/api";
import PublicInfoEdit from "@/components/PublicInfoEdit";

export default defineComponent({
  name: "PublicInfo",
  components: {
    PublicInfoEdit,
  },
  setup(_, { emit, root }) {
    const { authUserStrict } = useAuthUser();
    const values = ref({
      location: {
        city: "",
        stateCode: "",
        countryCode: "",
      },
      gender: Gender.UNDEFINED,
      preferredGender: PreferredGender.UNDEFINED,
      preferredPosition: RelationshipRole.UNDEFINED,
    });

    const saveFields = () => {
      return Promise.all([
        providers.UserPublicDataProvider.userPublicInformationUpdate({
          userId: authUserStrict.value.id,
          location: values.value.location,
          preferredGender: values.value.preferredGender ?? PreferredGender.UNDEFINED,
          preferredPosition: values.value.preferredPosition ?? RelationshipRole.UNDEFINED,
        }).then(r => updateHasLocation(r, root)),
        providers.UserProvider.update({
          data: {
            id: authUserStrict.value.id,
            gender: values.value.gender ?? Gender.UNDEFINED,
          },
        }).then(r => Store.commit(MUTATION_TYPES.SET_USER, r)),
      ]);
    };

    const setLocation = (value: BlockedLocationAutocomplete) => {
      values.value.location = value;
      emit("setValid", value.countryCode);
    };

    const getData = async () => {
      const response = await providers.UserPublicDataProvider.userPublicInformationFind(authUserStrict.value.id);
      if (response.location.countryCode) {
        emit("setValid", true);
      }
      values.value.location = response.location;
      values.value.gender = authUserStrict.value.gender;
      values.value.preferredGender = response.preferredGender;
      values.value.preferredPosition = response.preferredPosition;
    };

    const created = async () => {
      emit("setValid", false);
      emit("setCb", () => saveFields());
      try {
        emit("setLoading", true);
        await getData();
      } finally {
        emit("setLoading", false);
      }
    };

    created();

    return {
      values,
      setLocation,
    };
  },
});
